module.exports = __webpack_public_path__ + "static/img/flare.bd05fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/flare.png
// module id = XBni
// module chunks = 0